/**
 * The shared state behind useLenses, with no network code in it.
 *
 * Kept apart from the loader so setupTests.js can prime it without importing
 * the API client (see config/surfaces/store.js for why that matters).
 */
export const IDLE = Object.freeze({ status: 'idle', body: null, fingerprint: null, error: null });

let state = IDLE;
const listeners = new Set();

export const getState = () => state;

export const setState = (next) => {
  state = Object.freeze(next);
  listeners.forEach((l) => l());
};

export const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** The 'ready' state for a /lenses response body. */
export const readyState = (body) => ({
  status: 'ready', body, fingerprint: body?.fingerprint || null, error: null,
});

/** Fill the store from a /lenses response without fetching (tests). */
export const primeLenses = (body) => setState(readyState(body));

/** Forget what was loaded. */
export const resetState = () => setState(IDLE);
